import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import { Button, Card, Descriptions, Table, Tag } from 'antd';
import axios from 'axios'

const Patient = () => {
    const [patient, setPatient] = useState(null);
    const [jobs, setJobs] = useState([]);
    const { id } = useParams()
    const { navigate } = useNavigate()

    const fetchPatient = useCallback(() => {
        setPatient(null);
        axios
            .get(`/admins/patient/${id}`)
            .then(({ data }) => {
                setPatient(data);
            })
            .catch((error) => {
                navigate('/');
            });
    }, [])

    useEffect(() => {
        if (id) {
            fetchPatient()
            // Fetch patient's jobs
            axios.get(`/admins/patient/${id}/jobs`)
                .then(({ data }) => {
                    setJobs(data)
                })
                .catch((err) => {
                    console.error('Error fetching jobs:', err)
                })
        }
    }, [id, navigate]);

    const jobsColumns = [
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            render: (title, record) => (
                <Link to={`/jobs/${record._id}`}>{title}</Link>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => (
                <Tag color={
                    status === 'completed' ? 'green' :
                        status === 'canceled' ? 'red' :
                            status === 'late_canceled' ? 'orange' :
                                status === 'working' ? 'blue' : 'default'
                }>
                    {status.toUpperCase()}
                </Tag>
            ),
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (date) => new Date(date[0]).toLocaleDateString(),
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            render: (price) => `$${price}`,
        },
    ];

    return (
        <div className='patient'>
            {patient && (
                <>
                    <Card className="card">
                        <Descriptions title="Patient Info">
                            <Descriptions.Item label="Name">{patient.name}</Descriptions.Item>
                            <Descriptions.Item label="Surname">{patient.surname}</Descriptions.Item>
                            <Descriptions.Item label="Email">{patient.email}</Descriptions.Item>
                            <Descriptions.Item label="Phone">{patient.phone}</Descriptions.Item>
                            <Descriptions.Item label="Email Notifications">
                                <Tag color={patient.emailNotifications ? 'green' : 'red'}>
                                    {patient.emailNotifications ? 'Enabled' : 'Disabled'}
                                </Tag>
                            </Descriptions.Item>
                            {patient.location && (
                                <>
                                    <Descriptions.Item label="Address Line 1">{patient.location.addressLine1}</Descriptions.Item>
                                    <Descriptions.Item label="Address Line 2">{patient.location.addressLine2}</Descriptions.Item>
                                    <Descriptions.Item label="City">{patient.location.city}</Descriptions.Item>
                                    <Descriptions.Item label="State">{patient.location.state}</Descriptions.Item>
                                    <Descriptions.Item label="Zip Code">{patient.location.zipCode}</Descriptions.Item>
                                </>
                            )}
                        </Descriptions>
                    </Card>

                    <Card className="card" style={{ marginTop: '20px' }}>
                        <h3 style={{ marginBottom: '16px' }}>Job History</h3>
                        <Table
                            dataSource={jobs}
                            columns={jobsColumns}
                            rowKey="_id"
                        />
                    </Card>
                </>
            )}
        </div>
    )
}

export default Patient 